module.exports = __webpack_public_path__ + "assets/img/DS-master (2).83cb7082.jpg";